import React from "react"
import autobind from "class-autobind"
import { ETrendTimeScope, IGroupedTrend } from "../../../models/data/dashboard/Trends/TrendsData"
import TrendSummaryTrendLine from "./TrendSummaryTrendLine"
import TrendChangeChip from "./TrendChangeChip"

declare global {
    interface Window {
        Intercom: any
    }
}

interface IProps {
    groupedTrend: IGroupedTrend
    selected: boolean
    scope: ETrendTimeScope
}

interface IState {
}

export default class TrendSummaryPanelItem extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)
        autobind(this)
    }
        
    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        const groupedTrend = this.props.groupedTrend        
        const greenColor = "#3AAD07" 
        const redColor = "#F22803" 
        const border = this.props.selected ? "3px solid #1181F2" : null
        const bottomBorder = this.props.selected ? null : "1px solid #cccccc"
        const backgroundColor = this.props.selected ? "rgba(0, 0, 0, 0.5)" : null
        let chipColor = greenColor; 
        
        if((groupedTrend.Settings.AggregationSettings.NegativeGrowthPreferred && groupedTrend.Totals.ChangedValue > 0) || (!groupedTrend.Settings.AggregationSettings.NegativeGrowthPreferred && groupedTrend.Totals.ChangedValue < 0)){
            chipColor = redColor
        }

        return (
            <div style={{backgroundColor: backgroundColor, padding:5, paddingLeft: 10, borderBottom: bottomBorder, border: border, cursor: "pointer"}}
            >
                <div>
                    <div>
                        <h3 style={{marginBottom: 0, paddingBottom: 0}}>{groupedTrend.Settings.Name.toUpperCase()} - {groupedTrend.HierarchyName.toUpperCase()}</h3>
                        <p style={{marginTop: 0, fontSize: 10}}>{groupedTrend.Settings.Description}</p>
                    </div>
                    <div style={{display: "flex"}}>
                        <div style={{flex: 2}}>
                            <TrendSummaryTrendLine groupedTrend={groupedTrend} scope={this.props.scope} value={(groupedTrend.Totals ? groupedTrend.Totals.ChangedValue : 0)} settings={groupedTrend.Settings}/>                        
                        </div>
                        <div style={{flex: 1, paddingLeft: 5, position: "relative"}}>
                            <div style={{padding: 5, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                                <TrendChangeChip value={(groupedTrend.Totals ? groupedTrend.Totals.ChangedValue : 0)} settings={groupedTrend.Settings} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}